import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Container, Header } from "semantic-ui-react";

import UnauthorisedFeature from "../../components/auth/UnauthorisedFeature.jsx";
import Entity404 from "../../components/entity404/Entitiy404.jsx";
import SimplePreloader from "../../components/preloaders/SimplePreloader.jsx";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs.jsx";
import ActionDropdownMenu from "../../components/actionDropdownMenu/ActionDropdownMenu.jsx";
import ResourceMarker from "../../components/marking/ResourceMarker.jsx";
import ProjectSettingsForm from "../../components/projects/ProjectSettingsForm.jsx";
import ChallengeConfirmationModal from "../../components/modals/ChallengeConfirmationModal.jsx";

import { AT_TYPES, RESOURCE_URI_CHUNKS } from "../../constants/entity.js";
import { OPERATIONS } from "../../constants/operations.js";
import { PROJECTS } from "../../state/actions/actionConstants.js";
import { ROUTES } from "../../constants/routing.js";

import projectSelector from "../../state/reducers/projects/projectSelector.js";
import endpointSelector from "../../state/reducers/endpoints/endpointSelector.js";
import { operationAction } from "../../state/reducers/operations/operationActions.js";
import { getProject } from "../../state/reducers/projects/projectsActions.js";
import connectionsSelector from "../../state/reducers/connections/connectionsSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";
import { get } from "lodash";

class ProjectSettings extends PureComponent {
  static propTypes = {
    copyKey: PropTypes.string.isRequired,

    data: PropTypes.object,
    isFetching: PropTypes.bool.isRequired,
    listProjectAvailability: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired,

    getProject: PropTypes.func.isRequired,
    operationAction: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_settings"
  };

  constructor(props) {
    super(props);

    this.state = {
      atId: `/${RESOURCE_URI_CHUNKS.PROJECTS}/${props.match.params.id}`,

      showModal: false,
      modalCopyKey: "",
      modalData: {},
      modalAction: null
    };
  }

  componentDidMount = () => {
    const { listProjectAvailability, getProject } = this.props;
    if (listProjectAvailability.available) {
      getProject(this.state.atId, false, false);
    }
  };

  // -- HANDLERS & ACTIONS -- //

  handleDelete = (id, type) => {
    const modalCopyKey = `projects.modals.delete_modal`;
    const modalData = { id, type };
    const modalAction = this.doDelete;

    this.setState(
      {
        modalCopyKey,
        modalData,
        modalAction
      },
      this.openModal
    );
  };

  doDelete = () => {
    const { data, operationAction } = this.props;
    operationAction(data, OPERATIONS.DELETE);
  };

  // -- MODAL -- //

  openModal = () => {
    this.setState({ showModal: true });
  };

  closeModal = confirmed => {
    const { modalAction } = this.state;

    if (confirmed === true) modalAction();

    this.setState({ showModal: false });
  };

  // -- RENDER -- //

  getBreadcrumbSections = () => {
    const { copy, data } = this.props;

    return [
      { content: copy("navigation.projects"), href: ROUTES.PROJECTS },
      {
        content: get(data, "name", "Unknown"),
        href: get(data, "@id", "")
      },
      { content: copy("navigation.project_settings"), active: true }
    ];
  };

  render() {
    const { atId, modalCopyKey, showModal } = this.state;
    const {
      data,
      timeReceived,
      isFetching,
      listProjectAvailability: { permitted, enabled },
      copyKey,
      copy
    } = this.props;

    if (!permitted) {
      return <UnauthorisedFeature title={copy("projects.title")} />;
    }

    if (!data) {
      return null;
    }

    if (!enabled || (!data["@id"] && !isFetching)) {
      return <Entity404 id={atId} type={AT_TYPES.PROJECT} />;
    }

    return (
      <Fragment>
        {isFetching && <SimplePreloader />}
        <Container>
          <Breadcrumbs sections={this.getBreadcrumbSections()} />

          <ActionDropdownMenu
            onDelete={this.handleDelete}
            viewPath={data["@id"]}
            data={data}
            copy={copy("project_dropdown_menu")}
          />

          <Header as="h3" className="action-dropdown-header">
            {`${data.name} ${copy(`${copyKey}.title`)}`}
          </Header>

          <ResourceMarker marking={data.marking} className="project-marker" />

          <ProjectSettingsForm
            key={`project-form-${timeReceived}`}
            data={data}
          />

          {showModal && (
            <ChallengeConfirmationModal
              entity={data}
              open={showModal}
              onClose={this.closeModal}
              copyKey={modalCopyKey}
            />
          )}
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  data: projectSelector.selectProject()(state, props),
  connections: connectionsSelector.selectProjectConnections(state, props),
  timeReceived: `${state.projects.timeReceived}`,
  isFetching: state.projects.isFetching || state.connections.isFetching,
  listProjectAvailability: endpointSelector.selectOperationAvailability(state)(
    AT_TYPES.PROJECT,
    OPERATIONS.LIST
  ),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  getProject: (id, usage, resources) =>
    dispatch(getProject(id, usage, resources)),
  operationAction: (entity, operationName, data, options) =>
    dispatch(operationAction(PROJECTS, entity, operationName, data, options))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectSettings);
